import Vue from 'vue';
import VueRouter from 'vue-router';
import { trimEnd } from 'lodash';
import StoryEditor from '../views/StoryEditor.vue';
import StoryManage from '../views/StoryManage.vue';
import * as layouts from '../layouts';
import store from '../store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/editor/',
    name: 'StoryManage',
    component: StoryManage,
  },
  {
    path: '/editor/:storyId',
    name: 'StoryEditor',
    component: StoryEditor,
  },
  {
    path: '/story-test/pa-news/:storyId',
    name: 'StoryTestPaNews',
    component: () => import(/* webpackChunkName: "story" */ '../views/StoryTestPaNews.vue'),
  },
  {
    path: '/',
    name: 'Index',
    component: () => import(/* webpackChunkName: "index" */ '../views/Index.vue'),
  },
  // 要測試時再打開
  {
    path: '/test',
    name: 'Test',
    component: () => import(/* webpackChunkName: "test" */ '../views/Test.vue'),
  },
  {
    path: '/error',
    component: () => import(/* webpackChunkName: "error" */ '../views/ErrorPage.vue'),
  },
  {
    path: '*',
    component: () => import(/* webpackChunkName: "error" */ '../views/ErrorPage.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  try {
    let nextLayout = 'empty';
    const toPath = to.matched[0].path || to.path;
    // 換頁前先手動尋找對應 route
    for (const route of routes) {
      // 目前是直接透過 path 和 matched 比較，
      // 可支援的路由類型包含
      // 任何一般的路由(範例：/index)
      // 帶參數的路由 /abc/:id , /abc/:id1/:id2
      const rPath = trimEnd(route.path, '/');
      console.log(`${rPath} => ${toPath}`);
      if (rPath === toPath) {
        let component;
        if (route.component) {
          if (typeof route.component === 'function') {
            // eslint-disable-next-line no-await-in-loop
            const module = await route.component();
            component = module.default;
          } else {
            component = route.component;
          }
          // 尋找 {component}.layout 的屬性，如果找不到就設為 empty
          // 找到後同步至 store ，修改當前頁面的 layout 元件
          // console.log('component', component);
          if (component.layout && component.layout in layouts) {
            nextLayout = component.layout;
          }
          console.log('component.layout', component.layout);
          store.commit('SET_REQUIRE_LOGIN', !!component.requireLogin);
        }
        break;
      }
    }
    store.commit('CLEAR_AUTH_ERROR');
    store.commit('SET_LAYOUT', nextLayout);
    next();
  } catch (e) {
    console.error('error in router.beforeEach');
    console.error(e);
    store.commit('SET_LAYOUT', 'empty');
    next();
  }
});

export default router;
